import {FC,} from "react";
import {Route} from "react-router-dom";
import {Navigate, Routes} from "react-router";
import {LoanManagerCustomerListPage} from "./List";
import {LoanManagerCustomerFormPage} from "./Form";

export const LoanManagerCustomerPage: FC = () => {
  return (
      <Routes>
        <Route index element={<LoanManagerCustomerListPage/>}/>
        <Route path=":id" element={<LoanManagerCustomerFormPage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
  );
}


